import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

export function BoxNode(props) {
  const getIsCorrect = (c) => c.answerId.includes(c.droppedId);

  const getFeedback = (c, isCorrect) => {
    if (isCorrect) return "";
    else return c.feedbackMessage;
  };

  const getIsEmpty = (c) => c.droppedId === null;

  const onDropStep = (positionId) =>
    React.useCallback((params) => {
      props.onDropStep({ ...params, positionId, nodeId: props.nodeId });
    }, []);

  const onRemoveStep = (positionId) =>
    React.useCallback(() => {
      props.onRemoveStep({ positionId, nodeId: props.nodeId });
    }, []);

  const techniqueComponent = (nodeComponent) => {
    const isCorrect = getIsCorrect(nodeComponent);
    return React.createElement(props.techniqueNode, {
      isCorrect,
      key: nodeComponent.id,
      title: nodeComponent.title,
      image: nodeComponent.image,
      tabIndex: props.tabIndex,
      onDrop: onDropStep(nodeComponent.id),
      onRemove: onRemoveStep(nodeComponent.id),
      isEmpty: getIsEmpty(nodeComponent),
      droppedId: nodeComponent.droppedId,
      description: nodeComponent.description,
      placeHolder: nodeComponent.placeHolder,
      showTooltip: nodeComponent.showTooltip,
      ...props.techniqueNode.props,
      feedbackMessage: getFeedback(nodeComponent, isCorrect),
    });
  };

  return (
    <div className="design-view__boxNode">
      {props.nodeComponents.map(techniqueComponent)}
    </div>
  );
}

BoxNode.propTypes = {
  /**
   * List of Components too display in Node
   */
  nodeComponents: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Uniqe id of component
       */
      id: PropTypes.number,
      /**
       * Type of NodeComponent
       */
      type: PropTypes.oneOf(["TECHNIQUE_CARD"]),
      /**
       * Title of TechiniqueNode
       */
      title: PropTypes.string,
      /**
       * Description of TechiniqueNode
       */
      description: PropTypes.string,
      /**
       * Image URL for OutcomeNode
       */
      image: PropTypes.string,
      /**
       * Placeholder text when no Node is dropped
       */
      placeHolder: PropTypes.string,
      /**
       * Feedback message
       */
      feedbackMessage: PropTypes.string,
      /**
       * List of Ids' of Node/Component that are correct for the spot
       */
      answerId: PropTypes.arrayOf(PropTypes.number),
      /**
       * UniqueId of option dropped in the node
       */
      droppedId: PropTypes.arrayOf(PropTypes.number),
    })
  ),
  /**
   * React Component to use as Technique Component
   */
  techniqueNode: PropTypes.elementType,
};

BoxNode.defaultProps = {
  nodeComponents: [],
};
